import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import { blogAPI, servicesAPI } from '../../services/api';
import './SiteSearch.css';

// Site içi sayfa verileri (statik)
const staticPages = [
  { title: 'Ana Sayfa', path: '/', category: 'Sayfa' },
  { title: 'Kurumsal - Mobil Assistance Hakkında', path: '/tr/kurumsal/mobil-assistance-hakkinda', category: 'Kurumsal' },
  { title: 'Kurumsal Hedeflerimiz', path: '/tr/kurumsal/kurumsal-hedefler', category: 'Kurumsal' },
  { title: 'Kalite Politikamız', path: '/tr/kurumsal/kalite-politikamiz', category: 'Kurumsal' },
  { title: 'Tarihçemiz', path: '/tr/kurumsal/tarihcemiz', category: 'Kurumsal' },
  { title: 'Etik Kurallarımız', path: '/tr/kurumsal/etik-kurallarimiz', category: 'Kurumsal' },
  { title: 'Tanıtım Filmi', path: '/tr/kurumsal/tanitim-filmi', category: 'Kurumsal' },
  { title: 'Belgelerimiz', path: '/tr/kurumsal/kalite-belgelerimiz', category: 'Kurumsal' },
  { title: 'Kurumsal Kimlik', path: '/tr/kurumsal/kurumsal-kimlik', category: 'Kurumsal' },
  { title: 'Hizmetlerimiz', path: '/tr/hizmetlerimiz', category: 'Hizmetler' },
  { title: 'Yol Yardım Hizmeti', path: '/tr/hizmetlerimiz/yol-yardim-kurtarma-hizmeti', category: 'Hizmetler' },
  { title: 'İkame Araç Hizmeti', path: '/tr/hizmetlerimiz/ikame-arac-hizmeti', category: 'Hizmetler' },
  { title: 'Çağrı Merkezi Hizmeti', path: '/tr/hizmetlerimiz/cagri-merkezi-hizmeti', category: 'Hizmetler' },
  { title: 'Kişiye Özel Yol Yardım Paketleri', path: '/tr/hizmetlerimiz/kisiye-ozel-hizmet-paketleri', category: 'Hizmetler' },
  { title: 'Çekici Hizmeti', path: '/tr/hizmetlerimiz/cekici-hizmeti', category: 'Hizmetler' },
  { title: 'Assistance Altyapı Hizmeti', path: '/tr/hizmetlerimiz/asistans-altyapi-cozumleri', category: 'Hizmetler' },
  { title: 'Paket Satın Alma', path: '/tr/online-islemler/paket-satinalma', category: 'Online İşlemler' },
  { title: 'Sözleşme Ara', path: '/tr/online-islemler/sozlesme-ara', category: 'Online İşlemler' },
  { title: 'Bayilik Başvurusu', path: '/tr/online-islemler/bayilik-basvurusu', category: 'Online İşlemler' },
  { title: 'Tedarikçi Başvurusu', path: '/tr/online-islemler/tedarikci-basvurusu', category: 'Online İşlemler' },
  { title: 'Bayi Ağımız', path: '/tr/online-islemler/bayi-agimiz', category: 'Online İşlemler' },
//   { title: 'Paketler', path: '/tr/paketler', category: 'Paketler' },
//   { title: 'Motosiklet Paketleri', path: '/tr/paketler-motosiklet-yol-yardim-paketleri', category: 'Paketler' },
//   { title: 'Otomobil Paketleri', path: '/tr/paketler-otomobil-yol-yardim-paketleri', category: 'Paketler' },
//   { title: 'Hafif Ticari Paketleri', path: '/tr/paketler-hafif-ticari-yol-yardim-paketleri', category: 'Paketler' },
//   { title: 'Ağır Ticari Paketleri', path: '/tr/paketler-agir-ticari-yol-yardim-paketleri', category: 'Paketler' },
//   { title: 'İkame Araç Paketleri', path: '/tr/paketler-ikame-arac-yol-yardim-paketleri', category: 'Paketler' },
  { title: 'Blog', path: '/tr/blog', category: 'Blog' },
  { title: 'İletişim', path: '/tr/mobil-assistance/iletisim', category: 'Sayfa' },
  { title: 'İnsan Kaynakları', path: '/tr/mobil-assistance/insan-kaynaklari', category: 'Sayfa' },
];

const SiteSearch = ({ show, onHide }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [blogs, setBlogs] = useState([]);
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);
  const inputRef = useRef(null);
  const navigate = useNavigate();

  // Blog ve Hizmet verilerini yükle
  useEffect(() => {
    if (show) {
      const fetchData = async () => {
        setLoading(true);
        try {
          // Blog verilerini çek
          const blogResponse = await blogAPI.getBlogs();
          const blogData = blogResponse?.data?.data || [];
          const normalizedBlogs = blogData.map((item) => ({
            id: item.idBlog,
            slug: item.dsSlug,
            title: item.dsTitle,
            excerpt: item.dsExcerpt,
            content: item.dsContent,
            category: item.dsCategory || 'Blog',
            type: 'blog',
          }));
          setBlogs(normalizedBlogs);

          // Hizmet verilerini çek
          const servicesResponse = await servicesAPI.getServices();
          const servicesData = servicesResponse?.data?.data || [];
          const normalizedServices = servicesData.map((item) => {
            // Slug oluştur (dsSlug varsa kullan, yoksa dsTitle'dan oluştur)
            let slug = item.dsSlug || item.dsTitle?.toLowerCase()
              .replace(/ş/g, 's')
              .replace(/ğ/g, 'g')
              .replace(/ü/g, 'u')
              .replace(/ö/g, 'o')
              .replace(/ç/g, 'c')
              .replace(/ı/g, 'i')
              .replace(/[^a-z0-9]+/g, '-')
              .replace(/^-+|-+$/g, '');
            
            return {
              id: item.idServices,
              slug: slug,
              title: item.dsTitle,
              excerpt: item.dsExcerpt || item.dsDescription,
              content: item.dsContent || item.dsDescription,
              category: 'Hizmetler',
              type: 'service',
              path: `/tr/hizmetlerimiz/${slug}`,
            };
          });
          setServices(normalizedServices);
        } catch (error) {
          console.error('Veri alınamadı', error);
          setBlogs([]);
          setServices([]);
        } finally {
          setLoading(false);
        }
      };
      fetchData();
    }
  }, [show]);

  // Arama fonksiyonu
  const performSearch = useCallback((term) => {
    if (!term || term.trim().length < 2) {
      setResults([]);
      return;
    }

    const searchLower = term.toLowerCase().trim();
    const searchResults = [];

    // Statik sayfaları ara
    staticPages.forEach((page) => {
      if (
        page.title.toLowerCase().includes(searchLower) ||
        page.category.toLowerCase().includes(searchLower)
      ) {
        searchResults.push({
          ...page,
          type: 'page',
        });
      }
    });

    // Blog yazılarını ara
    blogs.forEach((blog) => {
      if (
        blog.title.toLowerCase().includes(searchLower) ||
        blog.excerpt?.toLowerCase().includes(searchLower) ||
        blog.content?.toLowerCase().includes(searchLower) ||
        blog.category?.toLowerCase().includes(searchLower)
      ) {
        searchResults.push({
          ...blog,
          path: `/tr/blog/${blog.slug}`,
        });
      }
    });

    // Hizmetleri ara
    services.forEach((service) => {
      if (
        service.title?.toLowerCase().includes(searchLower) ||
        service.excerpt?.toLowerCase().includes(searchLower) ||
        service.content?.toLowerCase().includes(searchLower) ||
        service.category?.toLowerCase().includes(searchLower)
      ) {
        searchResults.push(service);
      }
    });

    // Sonuçları kategorilere göre grupla
    const grouped = searchResults.reduce((acc, result) => {
      const category = result.category || 'Diğer';
      if (!acc[category]) {
        acc[category] = [];
      }
      acc[category].push(result);
      return acc;
    }, {});

    // Kategorilere göre sırala ve düzleştir
    const sortedCategories = Object.keys(grouped).sort();
    const flattened = sortedCategories.flatMap((category) => grouped[category]);

    setResults(flattened);
  }, [blogs, services]);

  // Arama terimi değiştiğinde ara
  useEffect(() => {
    if (show) {
      const timeoutId = setTimeout(() => {
        performSearch(searchTerm);
      }, 300); // Debounce 300ms

      return () => clearTimeout(timeoutId);
    }
  }, [searchTerm, show, performSearch]);

  // Modal açıldığında input'a focus
  useEffect(() => {
    if (show && inputRef.current) {
      setTimeout(() => {
        inputRef.current?.focus();
      }, 100);
    }
  }, [show]);

  // Sonuç tıklama handler'ı
  const handleResultClick = (result) => {
    navigate(result.path);
    onHide();
    setSearchTerm('');
    setResults([]);
  };

  // Modal kapatıldığında temizle
  const handleClose = () => {
    setSearchTerm('');
    setResults([]);
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="lg"
      className="site-search-modal"
      dialogClassName="site-search-dialog"
    >
      <Modal.Header closeButton className="site-search-header">
        <Modal.Title>
          <i className="fas fa-search me-2"></i>
          Site İçi Arama
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="site-search-body">
        <div className="search-input-wrapper">
          <input
            ref={inputRef}
            type="text"
            className="form-control site-search-input"
            placeholder="Aramak istediğiniz kelimeyi yazın..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Escape') {
                handleClose();
              }
            }}
          />
          {loading && (
            <div className="search-loading">
              <i className="fas fa-spinner fa-spin"></i>
            </div>
          )}
        </div>

        {searchTerm.length > 0 && searchTerm.length < 2 && (
          <div className="search-hint">
            <i className="fas fa-info-circle me-2"></i>
            En az 2 karakter giriniz
          </div>
        )}

        {searchTerm.length >= 2 && results.length === 0 && !loading && (
          <div className="search-no-results">
            <i className="fas fa-search me-2"></i>
            <p>Sonuç bulunamadı</p>
            <small>Farklı kelimeler deneyin</small>
          </div>
        )}

        {results.length > 0 && (
          <div className="search-results">
            <div className="search-results-header">
              <span>{results.length} sonuç bulundu</span>
            </div>
            <div className="search-results-list">
              {results.map((result, index) => (
                <div
                  key={`${result.type}-${result.id || result.path}-${index}`}
                  className="search-result-item"
                  onClick={() => handleResultClick(result)}
                >
                  <div className="result-icon">
                    {result.type === 'blog' ? (
                      <i className="fas fa-newspaper"></i>
                    ) : result.type === 'service' ? (
                      <i className="fas fa-cog"></i>
                    ) : (
                      <i className="fas fa-file-alt"></i>
                    )}
                  </div>
                  <div className="result-content">
                    <div className="result-title">{result.title}</div>
                    {result.excerpt && (
                      <div className="result-excerpt">{result.excerpt}</div>
                    )}
                    <div className="result-category">
                      <span className="badge">{result.category}</span>
                    </div>
                  </div>
                  <div className="result-arrow">
                    <i className="fas fa-chevron-right"></i>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {searchTerm.length === 0 && (
          <div className="search-placeholder">
            <i className="fas fa-search fa-3x mb-3"></i>
            <p>Site içinde arama yapın</p>
            <small>Sayfalar, blog yazıları ve hizmetlerimizi arayabilirsiniz</small>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default SiteSearch;

